import { render, staticRenderFns } from "./PdfList.vue?vue&type=template&id=833f2e04&"
import script from "./PdfList.vue?vue&type=script&lang=ts&"
export * from "./PdfList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports